module.exports = __webpack_public_path__ + "img/33rd_anniversary_0714-C.64a9f8f2.jpg";